import React, { PureComponent, Suspense } from 'react';
import Footer from 'shared-components/Footer'
import Header from 'shared-components/Header'
import LeftPanel from 'shared-components/LeftPanel'
import Breadcrumb from 'shared-components/Breadcrumb'
import { Container, Row, Col } from 'react-bootstrap'
import { getUserAgent, getMemberAccountNo, memberNameFormat, cacheManager } from '../helpers/util-common'
import { find, isEmpty, get } from 'lodash';
import IdentityDelegationBanner from 'modules/identityDelegationBanner';
import { IDENTITY_DELEGATION_FLAG, USER_INFO } from 'models/common.models';
const WCMSFooter = React.lazy(()=>import("shared-components/WCMS/WCMSFooter"));

class Layout extends PureComponent {

	state = {
		isAuthorizedPage: true, // Used to check permission on page,
		entitlementList:[],
		isMemberAccount: true
	}

	UNSAFE_componentWillMount() {
		const { userInfo } = this.props;
		// If Logged in user is a member, then only call Entitlement API
		if (userInfo && userInfo.isMember) {
			this.setState({ isMemberAccount: true });
		} else {
		  this.setState({ isMemberAccount: true });
		}
	  }

	componentDidMount() {
		const { name } = getUserAgent()
		if (name === 'Safari') {
			this.props.setSafariAutoFillInfo(true)
		}
		const {getEntitlementList}=this.props;		
		if (getMemberAccountNo())
			getEntitlementList(getMemberAccountNo(), (response) => this.setState({ entitlementList: response }))
	}

	componentDidUpdate(prevProps) {
		if (this.props.location !== prevProps.location) {
			window.scrollTo(0, 0)
		}
	}

	getMenuMappedList = () => {
		//this.props.setMenuMappedList(menuList);
	}

	openPrintRenewInvoice = () => {
		window.open(`${process.env.REACT_APP_MEETINGAPP_URL}/MyASTM/MembershipInfo/Membership-Renewal-Invoice`, "_blank", "", true);
	}

	logoutHandler = () => {
        this.props.logout();
    }
	  
	render() {
		const {userInfo}=this.props;
		const {entitlementList, isMemberAccount} = this.state;
		const customMenu = [];
    	let isRenew = null;
    	if (!isEmpty(entitlementList.menuList)) {
      	const membershipMenuList = find(entitlementList.menuList, { "title": "Membership" });
      	isRenew = find(membershipMenuList.child, { "title": "Renew Membership" });
    	}
    	if (isMemberAccount && !isEmpty(isRenew)) {
      	customMenu.push({
        parent: 'Membership',
        id: 'renew-invoice',
        title: 'Print Renewal Invoice',
        handleClick: this.openPrintRenewInvoice,
        indexAt: [3, 1]
      	});
    	}
		let demoGraphy=entitlementList.otherInfo && entitlementList.otherInfo.demographyDetails ? entitlementList.otherInfo.demographyDetails : {};
		let memberName = '';
		if (get(demoGraphy, 'FirstName')) {
		memberName = memberNameFormat(get(demoGraphy, 'FirstName'), get(demoGraphy, 'MiddleName'), get(demoGraphy, 'LastName'), 1);
		} else {
		memberName = memberNameFormat(get(userInfo, 'firstName'), '', get(userInfo, 'lastName'), 1);
		}
		let identityDelegation = cacheManager.getItem(USER_INFO) ? get(JSON.parse(cacheManager.getItem(USER_INFO)), IDENTITY_DELEGATION_FLAG) : null;
		let accountNo = getMemberAccountNo();
		const featureFlag = cacheManager.getItem("flagFeature") ? JSON.parse(cacheManager.getItem("flagFeature") ): null;
		
		return (
      <div className="app">
        <Header {...this.props} logoutHandler={this.logoutHandler} />
        {identityDelegation && (
          <IdentityDelegationBanner
            {...identityDelegation}
            accountNo={accountNo}
          />
        )}
        <Container>
          <Row>
            <Col xs={12} md={3} className="leftPanel">
              <LeftPanel
                {...this.props}
                memberHost={process.env.REACT_APP_MEETINGAPP_URL}
                customMenu={customMenu}
                isMemberApp={true}
                activePath={"/MyASTM/MyCommittees"}
                entitlementList={entitlementList}
                getMenuMappedList={this.getMenuMappedList}
                userObj={{
                  accountNumber: getMemberAccountNo(),
                  memberType: get(userInfo, "MembershipTypeId"),
                  name: memberName,
                  email: get(demoGraphy, "Email")
                    ? get(demoGraphy, "Email")
                    : get(userInfo, "email"),
                  organizationName: get(demoGraphy, "CompanyName")
                    ? get(demoGraphy, "CompanyName")
                    : get(demoGraphy, "FacilityName")
                    ? get(demoGraphy, "FacilityName")
                    : null,
                }}
                globalLinksURL={{
                  profile: process.env.REACT_APP_GLOBAL_PROFILE_URL,
                  membership: "/MyASTM",
                  campus: process.env.REACT_APP_GLOBAL_ASTM_CAMPUS_URL,
                  meetingsSymposia:
                    process.env.REACT_APP_GLOBAL_MEETING_SYMPOSIA_URL,
                  orders: process.env.REACT_APP_GLOBAL_ORDERS_URL,
                  compass: process.env.REACT_APP_GLOBAL_COMPASS_URL,
                  tracker: process.env.REACT_APP_GLOBAL_TRACKERS_URL,
                }}
                featureFlag={featureFlag}
              />
            </Col>
            <Col xs={12} md={9}>
              <Breadcrumb />
              {this.props.children}
            </Col>
          </Row>
        </Container>
        {featureFlag?.WcmsNavIntegration ? (
          <Suspense>
            <WCMSFooter />
          </Suspense>
        ) : (
          <Footer />
        )}
      </div>
    );
	}
}

export default Layout
